import { PageHeader } from '@components/PageHeader';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const PageHeaderSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Page Header"
      description="Headers for page-level content with optional actions."
      figmaNodeId="137-709"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>With Action</h3>
      <div className={styles.headerBox}>
        <PageHeader
          title="Generate Leads"
          showPrimaryAction
          primaryActionText="Add New Type"
          onPrimaryAction={() => alert('Action clicked!')}
        />
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Without Action</h3>
      <div className={styles.headerBox}>
        <PageHeader title="Settings" showPrimaryAction={false} />
      </div>
    </div>
  </section>
);
